/* tslint:disable:arrow-return-shorthand */

/**
 * modifySearch should not have modifications checked in.
 * Automation to come that will prevent modification.
 * Purposely NOT typed, so that additional fields can be added.
 */
export const interceptGraphQLResponse = ({ data, errors, extensions, headers }) =>
  // Work with data:
  // data.propertySearch.properties[0].name = 'Fake Property Name';

  // Work with errors:

  // Work with extensions:

  ({ data, errors, extensions, headers });
